import type { SVGProps } from "react";
const GazCodesLogoCircleSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    width="1em"
    height="1em"
    aria-hidden="true"
    {...props}
  >
    <circle cx={512} cy={512} r={512} fill="currentColor" opacity={0.2} />
    <g>
      <polygon
        points="403.81 575.25 577.83 267.61 512 153.6 201.84 690.75 616.59 690.65 555.28 575.25 403.81 575.25"
        fill="currentColor"
        fillRule="evenodd"
      />
      <polygon
        points="551.67 477.89 674.29 690.65 822.1 690.65 699.4 478.15 551.67 477.89"
        fill="currentColor"
        fillRule="evenodd"
      />
      <polygon
        points="822.1 690.65 822.16 690.75 822.16 690.65 822.1 690.65"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
export default GazCodesLogoCircleSmall;
